// react
import React, { Suspense } from "react";
import { useSelector } from "react-redux";

import PageTitle from "../../../components/PageTitle";
import Spinner from "../../../components/Spinner/ComponentLoader";
// components
import Config from "./Config";

// hooks
import { useCurrentRouteProps } from "../../../app/router";

import { getUserCompanyName } from "../../../selectors/app";

// load in the goal tree
const LazyTemplateCreate = React.lazy(() => import("./TemplateCreate"));

const TemplateCreateLazyLoader = () => {
	const routeProps = useCurrentRouteProps();
	const companyName = useSelector(getUserCompanyName);

	// before rendering the page, we need to set some properties in the config
	// object.
	const [finishedSetup, setFinishedSetup] = React.useState(false);

	React.useEffect(() => {
		Config.pageName = routeProps.pageName;
		setFinishedSetup(true);
	}, [routeProps.pageName]);

	if (!finishedSetup) {
		return <Spinner />;
	}

	return (
		<>
			{companyName && <PageTitle title={`Edit Workflow - ${companyName} - PerformYard`} />}
			<Suspense fallback={<Spinner />}>
				<LazyTemplateCreate />
			</Suspense>
		</>
	);
};

export default TemplateCreateLazyLoader;
